import { ref } from 'vue';
import { irstore } from '@/fetch/interface';
import axios from '@/axios';
import { checkErrorValue } from '@/utils/api';
import to from 'await-to-js';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

export function useModuleConfig() {
	const config = ref({});

	const loadModuleConfig = async moduleId => {
		const storeId = resolveStoreId();
		const pageId = resolvePageId();
		if (checkErrorValue(storeId) || checkErrorValue(pageId)) return;

		const queryApi = irstore.getDisplayModule(storeId, pageId, moduleId);

		const [err, res] = await to(axios.get(queryApi));
		if (err) return;

		config.value = res.data || {};
	};

	return {
		config,
		loadModuleConfig
	};
}
